import React from 'react';
import Spinner from '#components/Elements/Spinner/Spinner';
import { useLogout } from '#modules/api/User';
import configureStore from '#app/store/configureStore';
import { LOGOUT } from '#modules/state/LogOutAction';
import styles from './LogIn.scss';

export default function LogOutPage() {
  const onLogout = useLogout();
  const store = configureStore();
  const searchParams = new URLSearchParams(window?.location?.search);
  const handle = searchParams.get('handle');

  React.useEffect(() => {
    if (handle) {
      store.dispatch({ type: LOGOUT }); // Tokenized logout
      onLogout(`handle=${handle}`);
    }
  }, [handle, onLogout, store]);

  return (
    <div className={styles.loginSpinner}>
      <Spinner />
    </div>
  );
}
